export default __webpack_public_path__ + "static/media/question-circle.a68f1dcd.svg";